import { AxiosResponse } from 'axios'
import { HttpClient, buildParams } from '@opallabs/api'

type Moment = {
  id: string
}
type WorkflowFetcher = (arg: Array<Moment>) => Promise<AxiosResponse>

const getBuildParams = (
  moments: Array<Moment>
): Record<string, any> | undefined => {
  const momentIds = moments.map((moment) => moment.id)
  const params = buildParams({
    include: ['context'],
    limit: `${momentIds.length > 150 ? momentIds.length : 150}`,
    'expose[workflow][meta]': '',
    'filter[context.moment_id]': `${momentIds.join(',')}`,
  })
  return params
}

export const fetchWorkflowsByMoments: WorkflowFetcher = (moments) =>
  HttpClient().get('/workflows/v2/workflows', getBuildParams(moments))
